import axios from "axios";

const CASCADING_SELECT_FOR_ITEMS_CLASSNAME = "js-cascading-select-for-items";

class CascadingSelectForItems {
  apiDataStore = {};
  $dependentSelectElements = [];
  currentDependentSelectOptions = [];

  static attach(options) {
    let $selectElements = document.querySelectorAll(`.${CASCADING_SELECT_FOR_ITEMS_CLASSNAME}`);
    if (options && options.selector) {
      if (options.selector instanceof HTMLElement) {
        $selectElements = [options.selector];
      } else if (typeof options.selector === "string") {
        $selectElements = document.querySelectorAll(options.selector);
      }
    }
    if ($selectElements) {
      [...$selectElements].forEach(($selectElement) => {
        /* eslint-disable-next-line no-unused-vars */
        const cascadingSelectForItems = new CascadingSelectForItems($selectElement, options);
      });
    }
  }

  constructor($selectElement, options = {}) {
    this.selectConfigOptions = options;
    this.selectElement = $selectElement;
    this.selectElement.classList.add("cascading-select-for-items");
    if (this.selectElement.options[this.selectElement.selectedIndex]) {
      this.selectedValue = this.selectElement.options[this.selectElement.selectedIndex].value;
    }

    const { preloadApiPath, dependentSelect, dependentSelectUseApi, dependentSelectApiPath } =
      this.selectElement.dataset;
    if (preloadApiPath) {
      this.getOptionsWithApi(preloadApiPath);
      return;
    }

    if (dependentSelect) {
      const $targetContainer =
        this.selectElement.closest("[data-is-cascading-select-for-items-container='true']") ||
        document;
      this.$dependentSelectElements = $targetContainer.querySelectorAll(dependentSelect);
      [...this.$dependentSelectElements].forEach(($dependentSelectElement) => {
        if (dependentSelectUseApi) {
          this.dependentSelectApiPath = dependentSelectApiPath;
          this.attachDependentSelectWithApiBehaviour($dependentSelectElement);
        } else {
          this.attachDependentSelectBehaviour($dependentSelectElement);
        }
      });
    }
  }

  attachDependentSelectBehaviour($dependentSelectElement) {
    const $dependentSelectOptions = $dependentSelectElement.querySelectorAll("option");
    if ($dependentSelectOptions) {
      const currentDependentSelectOptions = [];
      [...$dependentSelectOptions].forEach(($dependentSelectOption) => {
        const { parentValue } = $dependentSelectOption.dataset;
        currentDependentSelectOptions.push({
          text: $dependentSelectOption.innerText,
          value: $dependentSelectOption.value,
          selected: !!$dependentSelectOption.getAttribute("selected"),
          parentValue
        });
      });
      this.currentDependentSelectOptions[$dependentSelectElement.name] =
        currentDependentSelectOptions;
    }

    this.selectElement.addEventListener("change", (e) => {
      this.selectedValue = e.target.value;
      this.filterSelectOptions($dependentSelectElement);
    });
    this.filterSelectOptions($dependentSelectElement);
  }

  filterSelectOptions($dependentSelectElement) {
    const curOptions = this.currentDependentSelectOptions[$dependentSelectElement.name];
    let filteredOptions = [];
    const firstOption = curOptions[0];
    const hasEmptyOption = firstOption && firstOption.value === "";
    let shouldSetDisable = false;
    const { disableIfEmpty, noFilterIfParentEmpty, disableText, enableText } =
      $dependentSelectElement.dataset;
    if (this.selectedValue) {
      filteredOptions = curOptions.filter(
        (optionObj) => optionObj.parentValue === this.selectedValue
      );
    } else {
      // no selectedValue or selectedValue is blank string
      /* eslint-disable-next-line no-lonely-if */
      if (noFilterIfParentEmpty) {
        filteredOptions = curOptions;
      }
    }

    if (filteredOptions.length === 0) {
      // 作品タイトルを選択してない
      if (disableIfEmpty && !this.selectedValue) {
        shouldSetDisable = true;
        filteredOptions[0] = firstOption;
      } else {
        /* eslint-disable-next-line no-lonely-if */
        if (hasEmptyOption) {
          filteredOptions[0] = firstOption;
        }
      }
    } else {
      /* eslint-disable-next-line no-lonely-if */
      if (hasEmptyOption) {
        filteredOptions = [firstOption, ...filteredOptions];
      }
    }

    $($dependentSelectElement)
      .prop("disabled", shouldSetDisable)
      .empty()
      .html(
        CascadingSelectForItems.generateOptions(
          filteredOptions,
          this.selectedValue,
          disableText,
          enableText
        )
      );

    // NOTE: Using jQuery trigger change does not seem to work
    $dependentSelectElement.dispatchEvent(new Event("change"));
  }

  attachDependentSelectWithApiBehaviour($dependentSelectElement) {
    const setupDependentSelect = ($selectionOption) => {
      const { value } = $selectionOption;
      const targetApiUrl = `${this.dependentSelectApiPath}?id=${value}`;
      // eslint-disable-next-line no-param-reassign
      $dependentSelectElement.dataset.preloadApiPath = targetApiUrl;
      this.getOptionsWithApi(targetApiUrl, $dependentSelectElement);
    };

    this.selectElement.addEventListener("change", (e) => {
      if (
        this.selectConfigOptions.interceptOnChange &&
        typeof this.selectConfigOptions.interceptOnChange === "function"
      ) {
        if (this.selectConfigOptions.interceptOnChange(e) === false) {
          return;
        }
      }
      setupDependentSelect(e.target.querySelector("option:checked"));
    });
    setupDependentSelect(this.selectElement.querySelector("option"));
  }

  getOptionsWithApi(preloadApiPath, $targetSelect = null) {
    const $currentSelect = $targetSelect || this.selectElement;
    const mapDataToSelectArray = (responseData) => {
      return responseData.map((item) => {
        return {
          value: item.value,
          text: item.label,
          selected: false
        };
      });
    };
    const setupSelectOptions = (selectOptionsData) => {
      $($currentSelect).empty().html(CascadingSelectForItems.generateOptions(selectOptionsData));
    };

    const { preloadApiAlwaysCall } = $currentSelect.dataset;
    if (preloadApiAlwaysCall !== "true") {
      if (this.apiDataStore[preloadApiPath] && this.apiDataStore[preloadApiPath].length > 0) {
        setupSelectOptions(this.apiDataStore[preloadApiPath]);

        return;
      }
    }

    axios({
      method: "GET",
      url: preloadApiPath,
      headers: {
        "X-Requested-With": "XMLHttpRequest"
      }
    })
      .then((response) => {
        this.apiDataStore[preloadApiPath] = mapDataToSelectArray(response.data);
        setupSelectOptions(this.apiDataStore[preloadApiPath]);
      })
      .catch(() => {
        // NOTE: if error, silent fail and do not update any data.
      });
  }

  static generateOptions(filteredOptions, selectedValue, disableText, enableText) {
    const options = filteredOptions;
    if (selectedValue) {
      options[0].text = enableText;
    } else {
      options[0].text = disableText;
    }
    return options.map((optionObj) => {
      return `<option value="${optionObj.value}"${
        optionObj.selected ? ' selected="selected"' : ""
      }>${optionObj.text}</option>`;
    });
  }
}

export { CascadingSelectForItems };
